// extracted by mini-css-extract-plugin
export default {"listWrapper":"GiftRegistryItemsEdit_listWrapper__+xFoj","buttonsWrapper":"GiftRegistryItemsEdit_buttonsWrapper__1xvR5"};